import { TipsAndUpdates } from '@mui/icons-material';
import { Box } from '@mui/material';
import { GREEN_BP } from 'theme';
import DashboardDescription from './DashboardDescription';
import { SxProps } from '@mui/material';

type Props = {
  children: React.ReactNode;
  sx?: SxProps;
  textSx?: SxProps;
};

export const DashboardTip = ({ children, sx, textSx }: Props) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'row', border: `1px solid ${GREEN_BP}90`, borderRadius: 2, p: 1, mx: 1, mb: 1, ...sx }}>
      <TipsAndUpdates sx={{ fontSize: 32, color: GREEN_BP, mr: 1, mt: 0.5 }} />
      <DashboardDescription sx={textSx}>{children}</DashboardDescription>
    </Box>
  );
};
